/**
 * @flow
 * @relayHash 73243ff8dbb054255aac7a78834c224c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type IndexingCategory_project$ref = any;
export type indexing_IndexingCategory_QueryVariables = {|
  host: string
|};
export type indexing_IndexingCategory_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: IndexingCategory_project$ref
  |}
|};
export type indexing_IndexingCategory_Query = {|
  variables: indexing_IndexingCategory_QueryVariables,
  response: indexing_IndexingCategory_QueryResponse,
|};
*/


/*
query indexing_IndexingCategory_Query(
  $host: String!
) {
  project(host: $host) {
    ...IndexingCategory_project
    id
  }
}

fragment IndexingCategory_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      cursor
      node {
        countNoindexedPages
        countNofollowedPages
        countDisallowedPages
        countDeepPages
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "indexing_IndexingCategory_Query",
  "id": null,
  "text": "query indexing_IndexingCategory_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...IndexingCategory_project\n    id\n  }\n}\n\nfragment IndexingCategory_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      cursor\n      node {\n        countNoindexedPages\n        countNofollowedPages\n        countDisallowedPages\n        countDeepPages\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "indexing_IndexingCategory_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "IndexingCategory_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "indexing_IndexingCategory_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countNoindexedPages",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countNofollowedPages",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countDisallowedPages",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countDeepPages",
                        "args": null,
                        "storageKey": null
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b83ff1801c2e31e7cc522dac7a03b68e';
module.exports = node;
